/**
 * @namespace {BX.UI}
 */
export default class SplitButtonState
{
	static HOVER = 'ui-btn-hover';
	static MAIN_HOVER = 'ui-btn-main-hover';
	static MENU_HOVER = 'ui-btn-menu-hover';
	static ACTIVE = 'ui-btn-active';
	static MAIN_ACTIVE = 'ui-btn-main-active';
	static MENU_ACTIVE = 'ui-btn-menu-active';
	static DISABLED = 'ui-btn-disabled';
	static MAIN_DISABLED = 'ui-btn-main-disabled';
	static MENU_DISABLED = 'ui-btn-menu-disabled';
	static CLOCKING = 'ui-btn-clock';
	static WAITING = 'ui-btn-wait';
}